import React from 'react';
import dynamic from 'next/dynamic';
import CustomHead from '../components/common/head/Head';
import { apiUrl } from '../config/apiConfig';
import axios from 'axios';
import { metaSiteTitle } from '../config/defaultMetaConfig';

const HeroArea = dynamic(() => import('../components/pages/case-studies/HeroArea'), {
  loading: () => {
    return ""
  }, ssr: false
});
const CaseListArea = dynamic(() => import('../components/pages/case-studies/CaseListArea'), {
  loading: () => {
    return ""
  }, ssr: false
});
const ContactUsArea = dynamic(() => import('../components/pages/homepage/ContactUsArea'), {
  loading: () => {
    return ""
  }, ssr: false
});

const CaseStudiesPage = ({ siteSetting }) => {
  // console.log("siteSetting", siteSetting);
  return (<>
    <CustomHead
      title={"Our Case Studies | " + (siteSetting && siteSetting.title ? siteSetting.title : metaSiteTitle)}
    />
    <div className="page-area homepage-area mh-80v">
      <HeroArea />
      <CaseListArea />
      <ContactUsArea siteSetting={siteSetting} />
    </div>
  </>)
}

export async function getServerSideProps() {
  try {
    const siteSetting = await axios.get(apiUrl + '/api/siteSetting')
      .then((response) => {
        return response.data.data
      })
      .catch((error) => {
        return null
      });


    return {
      props: {
        siteSetting: siteSetting,
        loaded: true,
      }
    }
  } catch (error) {
    return {
      props: {
        siteSetting: null,
        loaded: true,
      }
    }
  }
}

export default CaseStudiesPage;